import type { Client } from '@sr-sdks/api-sdk-axios';
import {
  type ClientsPaginatedParams,
  fetchClientsPaginated,
} from '../../../api/workspaces/clientApi';
import { formatRepresentationStatus } from '../../../components/ClientCard/clientMeta';
import { csvRequestConfig } from '../../../utils/csv/csvExport';
import { csvColumn, csvDate } from '../../../utils/csv/toCsvChunk';
import { ensureStableSort } from '../../../utils/helpers/sort';

const col = csvColumn<Client>;

/**
 * The Clients column allowlist: the card's fields only (APP-2510 D15, D16).
 * Phone, website and the other contact fields are left out on purpose.
 */
export const clientsCsvColumns = [
  col('clientName', 'Client name', (row) => row.clientName),
  // Raw reference id: the card's "Client ID: " prefix would be noise in a column.
  col('clientId', 'Client ID', (row) => row.clientReferenceId),
  col('representationStart', 'Representation start', (row) =>
    csvDate(row.representationStartDate),
  ),
  col('representationEnd', 'Representation end', (row) =>
    csvDate(row.representationEndDate),
  ),
  col('status', 'Status', (row) =>
    formatRepresentationStatus(row.representationStatus),
  ),
];

/** The list's sort is required, so the file follows the order on screen. */
export const fetchClientsCsvPage = (
  params: ClientsPaginatedParams & { sortBy: string },
  page: number,
  pageSize: number,
  signal: AbortSignal,
) =>
  fetchClientsPaginated(
    { ...params, page, pageSize, sortBy: ensureStableSort(params.sortBy) },
    csvRequestConfig(signal),
  );
